import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  Action as GradProgramsAction,
  gradProgramsReducer as gradPrograms,
} from './gradPrograms';

export const gradSchoolsReducer = combineReducers<
  {
    gradPrograms: typeof gradPrograms;
  },
  GradProgramsAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  gradPrograms,
});
